export default __webpack_public_path__ + "static/media/shopify-step-1.8b1d9831.png";